import { Component, OnInit } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subscription } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-report-total-voters',
  templateUrl: './report-total-voters.component.html',
  styleUrls: ['./report-total-voters.component.css']
})
export class ReportTotalVotersComponent implements OnInit {

  constructor(private storage: StorageMap, private reportService: ReportService) { }

  openSpaceId: number;
  dataSubscription: Subscription;
  totalVoters = 0;

  ngOnInit(): void {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
    .subscribe((openId) => {
      const openIdInt = parseInt(openId, 10);
      if (!isNaN(openIdInt)){
        this.openSpaceId = openIdInt;
        this.getAllVoters(this.openSpaceId);
      }
    });

  }

  getAllVoters(openSpaceId: number){
    this.reportService.getTotalVoters(openSpaceId).subscribe(
      data => {
        if (data)
        {
          this.totalVoters = data.totalVoters;
        }
      },
      error => {
        console.error(error);
      }
    );
  }

}
